var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKahunLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24ZM24.0035 30.2221L10.6666 16.7736L14.0785 13.3332L24.0035 23.3411L33.9213 13.3332L37.3333 16.7736L24.0035 30.2221ZM37.3333 30.2221H10.6667V34.6666H37.3333V30.2221Z",
    fill: "#5A52C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKahunLogoIcon);
export default __webpack_public_path__ + "static/media/kahunLogoIcon.915f2ed1275595b7b3f36829364703bd.svg";
export { ForwardRef as ReactComponent };